export interface Lamp {
  /** Workspace-local id (selection, history, 3D userData). Not sent to the API. */
  id: string;
  /** Persisted luminaire id — matches `Version.lights[].uuid` and market-match `tamanLuminaireUuid`. */
  uuid: string;
  name: string;
  position: [number, number, number];
  distanceToGround: number;
  lumenOutput?: number;
  iesFileId?: number;
  /** Catalogue product assigned to this luminaire position (market-matched versions). */
  productId?: number;
  /** Catalogue variant assigned to this luminaire position (market-matched versions). */
  variantId?: number;
  /** Catalogue series of the assigned product (denormalized for deep links / picker restore). */
  seriesId?: number;
  /** Catalogue manufacturer of the assigned product (denormalized for deep links / picker restore). */
  manufacturerId?: number;
  /** Rotation of the assigned catalogue luminaire around the vertical axis. */
  rotationRadians?: number;
  /**
   * Optional market-match variant group. Luminaires sharing the same group receive the same
   * catalogue variant when market matching runs.
   */
  marketMatchGroup?: string;
  isSelected?: boolean;
}

/** Payload for creating lamps; pass `uuid` when hydrating from `Version.lights`. */
export type LampSeed = {
  name: string;
  position: [number, number, number];
  distanceToGround?: number;
  lumenOutput?: number;
  iesFileId?: number;
  productId?: number;
  variantId?: number;
  seriesId?: number;
  manufacturerId?: number;
  rotationRadians?: number;
  marketMatchGroup?: string;
  id?: string;
  uuid?: string;
};

export function createLampFromSeed(seed: LampSeed): Lamp {
  const { id: seedId, uuid: seedUuid, ...rest } = seed;
  return {
    ...rest,
    id: seedId ?? crypto.randomUUID(),
    uuid: seedUuid ?? crypto.randomUUID(),
    isSelected: false,
  } as Lamp;
}
